import { reportError } from '@perpay-web/utils/errorHandlers';
import { noop } from '@perpay-web/utils/noop';

export const clearSessionStorage = () => {
    try {
        window.sessionStorage.clear('isApplicationInProgress');
        window.sessionStorage.clear('currentStep');
    } catch (e) {
        reportError('Error clearing window.sessionStorage', e);
    }
};

export const createSessionStorageCacheService = (key) => ({
    store: (data) => {
        try {
            window.sessionStorage.setItem(key, JSON.stringify(data));
        } catch {
            noop();
        }
    },
    retrieve: () => {
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch {
            noop();
            return null;
        }
    },
    clear: () => {
        try {
            window.sessionStorage.removeItem(key);
        } catch {
            noop();
        }
    },
});
